// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"04bf6c35","496":"2dd34ca3","501":"4b120c95"}[chunkId] + ".chunk.js";
};